import React from 'react';
import {withStyles} from '@material-ui/core/styles';


function DescriptionList(props) {
  const {classes} = props;

  return (
    <div className={classes.main}>
      {props.children}
    </div>
  )
}

const dlStyles = {
  main: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  }
};

export default withStyles(dlStyles)(DescriptionList);



// WEBPACK FOOTER //
// ./src/shared/DescriptionList.js